const CrossSectionConf = {
    "left_ruler_width": 40.0,
    "right_ruler_width": 40.0,
    "bottom_ruler_height": 40.0,
    "top_margin": 28.0,
    "ruler_font_size": 12,
    "alt_unit_text": "FL",
    "mouse_wheel_zoom_rate": 0.001,
    "background_color": ["#000000", "#ffffff"],
    "ruler_background_color": ["rgb(10, 10, 10)", "#ffffff"],
    "ruler_text_color": ["rgb(255, 255, 255)", "#000000"],
    "ruler_line_color": ["rgb(200, 200, 200)", "#333333"],
    "port_text_color": ["rgb(255, 100, 0)"],
    "section_label_style": "color",
    "section_label_format": "minimize",
    "section_line_color": ["rgba(100,220,200,180)"],
    "section_label_color": ["rgb(255,255,255)"],
    "section_line_width": 1.5,
    "section_label_bg_color_acos": ["rgb(0,100,0)"],
    "section_label_bg_color_asc": ["rgb(83,126,153)"],
    "section_label_bg_color_model": ["rgb(0,0,128)"],
    "section_label_font_size": 10,
    "section_division_type": "time",
    "plan_route_mark_size": 5,
    "plan_route_mark_color": ["rgb(255, 255, 255)", "rgb(0, 0, 0)"],
    "plan_route_line_width": 3,
    "plan_route_line_hit_width": 8,
    "plan_route_line_color": ["rgb(255, 0, 255)"],
    "route_direction_color": ["rgba(200, 200, 200, 0.75)", "rgba(51, 51, 51, 0.75)"],
    "basic_decimate": true,
    "selectable_route": true,
    "interpolate_fix": true,
    "cs_interval_distance": {
        "UKMET": 10,
        "ASC_SCALE": 10,
        "LFM": 1.5,
        "GSM": 5,
        "MSM": 3,
        "GFS": 5
    },
    "element": [
        {
            "name": "WindBirb",
            "style": [
                {
                    "strokeStyle": "rgba(255,255,255,0.5)",
                    "fillStyle": "rgba(255,255,255,0.5)",
                    "lineWidth": 1
                },
                {
                    "strokeStyle": "rgba(0,0,0,0.5)",
                    "fillStyle": "rgba(0,0,0,0.5)",
                    "lineWidth": 1
                }
            ],
            "thin_out": {
                "thin_out": true,
                "thin_out_height": 500,
                "thin_out_interval": 2
            }
        },
        {
            "name": "Tropopause",
            "style": [
                {
                    "font": "12px Arial",
                    "textAlign": "center",
                    "textColor": "#dd0000"
                }
            ]
        },
        {
            "name": "IcingProb",
            "style": [
                {
                    "font": "12px Arial",
                    "textAlign": "center",
                    "textColor": "#ffffff"
                },
                {
                    "font": "12px Arial",
                    "textAlign": "center",
                    "textColor": "#444444"
                }
            ]
        },
        {
            "name": "Isotach",
            "contour": [
                {
                    "base":20,
                    "interval":20,
                    "num": 4,
                    "style": [
                    {
                       "strokeStyle": "rgb(7,206,255)",
                       "textColor": "rgb(7,206,255)",
                       "lineWidth": 1.01
                    }
                    ]
                },
                {
                    "base":100,
                    "interval":20,
                    "num": 1,
                    "style": [
                    {
                        "strokeStyle": "rgb(7,206,255)",
                        "fillStyle": "rgba(60,150,60, 0.3)",
                        "textColor": "rgb(7,206,255)",
                        "lineWidth": 1.01
                    }
                    ]
                },
                {
                    "base":160,
                    "interval":20,
                    "num": 1,
                    "style": [
                    {
                        "strokeStyle": "rgb(7,206,255)",
                        "fillStyle": "rgba(200,200,200, 0.3)",
                        "textColor": "rgb(87,206,255)",
                        "lineWidth": 1.01
                    }
                    ]
                },
                {
                    "base":120,
                    "interval":20,
                    "num": 4,
                    "style": [
                    {
                        "strokeStyle": "rgb(7,206,255)",
                        "textColor": "rgb(7,206,255)",
                        "lineWidth": 1.01
                    }
                    ]
                }
            ],
            "label_position": {
                "min": 0.4,
                "max": 0.6
            }
        },
        {
            "name": "Isotherm",
            "contour": [
                {
                    "base":-100,
                    "interval":5,
                    "num": 80,
                    "style": [
                    {
                          "strokeStyle": "rgb(200,40,40)",
                          "textColor": "rgb(200,40,40)",
                          "lineWidth": 1.01
                    }
                    ]
                }
            ],
            "label_position": {
                "min": 0.3,
                "max": 0.4
            }
        },
        {
            "name": "VWS",
            "contour": [
                {
                    "base":6,
                    "interval":3,
                    "num": 2,
                    "style": [
                    {
                        "strokeStyle": "rgb(0,255,0)",
                        "textColor": "rgb(0,255,0)",
                        "lineWidth": 3
                    }
                    ]
                },
                {
                    "base":12,
                    "interval":3,
                    "num": 1,
                    "style": [
                    {
                        "strokeStyle": "rgb(255,255,0)",
                        "textColor": "rgb(255,255,0)",
                        "lineWidth": 3
                    }
                    ]
                },
                {
                    "base":15,
                    "interval":3,
                    "num": 10,
                    "style": [
                    {
                        "strokeStyle": "rgb(255,0,0)",
                        "textColor": "rgb(255,0,0)",
                        "lineWidth": 3
                    }
                    ]
                }
            ],
            "label_position": {
                "min": 0.2,
                "max": 0.8
            }
        },
        {
            "name": "EqvPT",
            "contour": [
                {
                    "base":200,
                    "interval":5,
                    "num": 40,
                    "style": [
                    {
                        "strokeStyle": "rgb(107,121,127)",
                        "textColor": "rgb(150,150,150)",
                        "lineWidth": 1.01
                    }
                    ]
                }
            ],
            "label_position": {
                "min": 0.2,
                "max": 0.8
            }
        },
        {
            "name": "TMinusTD",
            "contour": [
                {
                    "base":3,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                              "test" : "hello",
                        "strokeStyle": "rgb(200,190,190)",
                        "textColor": "rgb(200,190,190)",
                        "fillStyle": "rgba(150,150,150, 0.3)",
                        "lineWidth": 2
                    }
                    ]
                }
            ],
            "label_position": {
                "min": 0.2,
                "max": 0.8
            }
        },
        {
            "name": "SATCLD",
            "style": [
                {
                    "strokeStyle": "rgb(200,200,200)",
                    "lineWidth": 2
                },
                {
                    "strokeStyle": "rgb(158,164,148)",
                    "lineWidth": 2
                }
            ]
        },
        {
            "name": "ELEVATION",
            "style": [
                {
                    "strokeStyle": "rgb(201,162,65)",
                    "fillStyle": "rgba(201,162,65,0.7)",
                    "lineWidth": 2,
                    "lineJoin" : "bevel"
                },
                {
                    "strokeStyle": "rgb(201,162,65)",
                    "fillStyle": "rgba(201,162,65,0.7)",
                    "lineWidth": 2,
                    "lineJoin" : "bevel"
                }
            ]
        },
        {
            "name": "TERRAIN_ELEVATION",
            "elevation": {
                "style": [
                    {
                        "strokeStyle": "#ff9900",
                        "lineWidth": 2,
                        "lineJoin" : "bevel"
                    },
                    {
                        "strokeStyle": "#ff9900",
                        "lineWidth": 2,
                        "lineJoin" : "bevel"
                    }
                ]
            },
            "updown": {
                "style": [
                    {
                        "strokeStyle": "#f9cb9c",
                        "lineWidth": 2,
                        "lineDash": [4, 3],
                        "lineJoin" : "bevel"
                    },
                    {
                        "strokeStyle": "#f9cb9c",
                        "lineWidth": 2,
                        "lineDash": [4, 3],
                        "lineJoin" : "bevel"
                    }
                ]
            },
        },
        {
            "name": "ASC_SCALE_TURBULENCE",
            "contour_fill_method": "drawASCScaleFill",
            "contour": [
                {
                    "base":2.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(255,182,193,0.5)"
                    }
                    ]
                },
                {
                    "base":3.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(255,105,180,0.5)"
                    }
                    ]
                },
                {
                    "base":4.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(255,0,0,0.5)"
                    }
                    ]
                }
            ]
        },
        {
            "name": "ASC_SCALE_CONVECTION",
            "contour": [
                {
                    "base":0.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(152,251,152,0.5)"
                    }
                    ]
                },
                {
                    "base":1.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(0,128,0,0.5)"
                    }
                    ]
                }
            ]
        },
        {
            "name": "ASC_SCALE_ICING",
            "contour": [
                {
                    "base":0.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(0,255,255,0.5)"
                    }
                    ]
                },
                {
                    "base":1.5,
                    "interval":0,
                    "num": 1,
                    "style": [
                    {
                        "fillStyle": "rgba(0,0,255,0.5)"
                    }
                    ]
                }
            ]
        },
        {
            "name": "ACOS",
            "expand_validtime": true,
            "contour": [
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 24,
                    "style": [
                        {
                            "strokeStyle": "rgb(106, 55, 167)",
                            "fillStyle": "rgba(106, 55, 167,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 21,
                    "style": [
                        {
                            "strokeStyle": "rgb(197, 78, 160)",
                            "fillStyle": "rgba(197, 78, 160,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 18,
                    "style": [
                        {
                            "strokeStyle": "rgb(35, 110, 241)",
                            "fillStyle": "rgba(35, 110, 241,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 15,
                    "style": [
                        {
                            "strokeStyle": "rgb(73, 221, 194)",
                            "fillStyle": "rgba(73, 221, 194,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 12,
                    "style": [
                        {
                            "strokeStyle": "rgb(255, 255, 0)",
                            "fillStyle": "rgba(255, 255, 0,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 9,
                    "style": [
                        {
                            "strokeStyle": "rgb(76, 158, 8)",
                            "fillStyle": "rgba(76, 158, 8,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 6,
                    "style": [
                        {
                            "strokeStyle": "rgb(234, 100, 255)",
                            "fillStyle": "rgba(234, 100, 255,0.5)",
                            "lineWidth": 2
                        }
                    ]
                },
                {
                    "base":0.7,
                    "interval":0,
                    "num": 1,
                    "ft": 3,
                    "style": [
                        {
                            "strokeStyle": "rgb(220, 107, 44)",
                            "fillStyle": "rgba(220, 107, 44,0.5)",
                            "lineWidth": 2
                        }
                    ]
                }
            ]
        }
    ],
    'route_altitude_gradation_settings': [
        [
            {alt: 53000, 'color': 'rgba(106,27,154, 0.8)'},
            {alt: 5000, 'color': 'rgba(0, 0, 128, 0.8)'},
            {alt: 3000, 'color': 'rgba(21, 101, 192, 0.8)'},
            {alt: 2000, 'color': 'rgba(0, 131, 143, 0.8)'},
            {alt: 1000, 'color': 'rgba(0, 128, 0, 0.8)'},
            {alt: 700, 'color': 'rgba(158, 157, 36, 0.8)'},
            {alt: 500, 'color': 'rgba(249, 168, 37, 0.8)'},
            {alt: 300, 'color': 'rgba(239, 108, 0, 0.8)'},
            {alt: 200, 'color': 'rgba(198, 40, 40, 0.8)'},
            {alt: 100, 'color': 'rgba(128, 0, 0, 0.8)'}
        ]
    ],
    'preferred_layer_order': [
        ['_model_layer', 'grid'],
        ['_model_layer', 't_minus_td'],
        ['_model_layer', 'eqv_pt'],
        ['_model_layer', 'isotherm'],
        ['_model_layer', 'isotach'],
        ['_model_layer', 'vws'],
        ['_model_layer', 'wind'],
        ['_model_layer', 'icingprob'],
        ['_model_layer', 'tropopause'],
        ['_model_layer', 'label'],
        ['_acos_layer', 'vaa'],
        ['_elevation_layer', 'hgt'],
        ['_elevation_layer', 'mte'],
        ['_satcld_layer', 'hgt'],
        ['_mainroute_layer', 'act']
    ]
}

export default CrossSectionConf;
